/**
 * Onglets & cartes — Daruma
 *
 * Bascule entre les groupes de cartes au clic sur un onglet. Le défilement
 * lui-même (glisser, flèches, molette) est assuré par les composants natifs
 * du thème (scroll-carousel, carousel-prev/next-button).
 *
 * Dans l'éditeur Shopify, sélectionner un bloc « Carte » active son onglet
 * et fait défiler jusqu'à la carte ; sélectionner un bloc « Onglet » l'active.
 */

class DarumaTabsCards extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tc-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-tc-panel]'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
    });

    this.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-tc-panel]');

      if (panel) {
        const index = this.panels.indexOf(panel);

        if (index >= 0) {
          this.activate(index);
        }

        event.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        return;
      }

      const tabIndex = this.tabs.indexOf(event.target.closest('[data-tc-tab]'));

      if (tabIndex >= 0) {
        this.activate(tabIndex);
      }
    });
  }

  activate(index) {
    this.tabs.forEach((tab, i) => {
      tab.classList.toggle('is-active', i === index);
      tab.setAttribute('aria-selected', String(i === index));
    });

    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}

if (!window.customElements.get('daruma-tabs-cards')) {
  window.customElements.define('daruma-tabs-cards', DarumaTabsCards);
}
